import globalConfiguration from '@/api/config/globalConfiguration'
import { queryKeys } from '@/constant/common'
import { CreateGlobalConfiguration } from '@/types/globalConfiguration'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function create(payload: CreateGlobalConfiguration): Promise<void> {
  await globalConfiguration.create(payload)
}

function useAddGlobal() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: CreateGlobalConfiguration) => create(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.globalConfiguration])
      toast.success(t('addGlobalConfigurationSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      if (error?.statusCode === 400) {
        toast.error(error?.message)
      } else toast.error(t('addGlobalConfigurationError'))
    },
  })
}

export default useAddGlobal
